/**
 * Mark — Awardy logo mark.
 * Inline SVG rounded-square with a bold "A", P.terracotta fill.
 * Atom purity: imports only react + tokens.
 */
import { P, T } from '../../styles/tokens';

export interface MarkProps {
  size?: number;
}

export function Mark({ size = 24 }: MarkProps) {
  const r = Math.round(size / 3);
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: r,
        background: P.terracotta,
        color: '#ffffff',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontFamily: T.fontDisplay,
        fontSize: Math.round(size * 0.58),
        fontWeight: 700,
        flexShrink: 0,
        userSelect: 'none',
      }}
      aria-hidden="true"
    >
      A
    </div>
  );
}
